<template>
  <div>
    <div>
      <top-menu 
        :backVisible="true"
        :homeVisible="true"
        :aboutVisible="false"
      >
      </top-menu>
    </div>
    <div>
        <v-container fluid class="ma-0 pa-0 mt-6">
          <v-row v-if="submitted == false">
            <v-col justify="center" class="ma-0 pa-0">
              <v-card class="ma-0 pa-0" flat>
                <v-card-title class="justify-center headline font-weight-black" dense>
                  <span class="blue--text text--darken-4 mb-4">Mission Position Report</span>
                </v-card-title>
                <v-card-subtitle class="text-center subtitle-2" dense>
                  <span class="blue--text text--center text--darken-4 mb-4">This allows you while on base to report your current location.  Please note you will be asked to allow the app to use you location, but understand it is only when you click the button.  We are not capturing location data in the background.</span>
                </v-card-subtitle>
                <v-card-text class="text-center">
                  <v-layout justify-center>
                    <v-row>
                      <v-col>
                        <v-select 
                          style="width:200px; margin-left: auto; margin-right:auto;" 
                          outlined 
                          dense
                          label="Mission Number"
                          v-model="mission"
                          :items="missions"
                          item-text="mission"
                          item-value="mission"
                          @change="updateSortiesForMission($event)"
                        >
                        </v-select>
                        <v-select 
                          v-if="mission != ''"
                          style="width:200px; margin-left: auto; margin-right:auto;" 
                          outlined 
                          dense
                          label="Sortie Number"
                          v-model="sortie"
                          :items=sorties
                          item-text="sortie"
                          item-value="sortie"
                          @change="getPwdForSortie($event)"
                        >
                        </v-select>
                      </v-col>
                    </v-row>
                  </v-layout>
                </v-card-text>

                  <v-card-actions class="justify-center">
                    <v-btn class="white--text" color="blue darken-4" @click="showPasswordVerification=true">Send Position Update</v-btn>
                  </v-card-actions>
                
              </v-card>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col justify="center" class="ma-0 pa-0">
              <v-card class="ma-0 pa-0" flat>
                <v-card-title class="justify-center subtitle-1 font-weight-black" dense>
                  <span class="blue--text text--darken-4 mb-4">Mission Position Report Submitted</span>
                </v-card-title>
                <v-card-subtitle class="text-center subtitle-2" dense>
                  
                </v-card-subtitle>
                <v-card-text class="text-center">
                  <v-container justify-center>
                    <v-row no-gutters>
                      <v-col>
                        <span><strong>Mission: </strong>{{sentObject.mission}}</span>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col>
                        <span><strong>Sortie: </strong>{{sentObject.sortie}}</span>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col>
                        <span><strong>Time (local): </strong>{{getLocalTime(sentObject.time)}}</span>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col>
                        <span><strong>Latitude: </strong>{{parseFloat(sentObject.lat).toFixed(2)}}</span>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col>
                        <span><strong>Longitude: </strong>{{parseFloat(sentObject.lon).toFixed(2)}}</span>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                  <v-card-actions class="justify-center">
                    <v-btn color="blue darken-4 white--text" @click.native="$router.push({ path: '/' })">Close</v-btn>
                  </v-card-actions>
                
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </div>

      <v-dialog
        v-model="showPasswordVerification"
        persistent
        max-width="500px"
      >
        <v-card height="225px">
          <v-card-title class="justify-center">
            Password Verification
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row v-if="passwordError == true" no-gutters class="red darken-4 white--text ma-0 pa-0">
                <v-col class="white--text text-center ma-0 pa-0">
                  <span class="white--text">Doesn't Match Sortie Password</span>
                </v-col>
              </v-row>
              <v-row no-gutters class="ma-0 pa-0">
                <v-col>
                  <v-text-field hide-details v-model="enteredPwd" label="Password"></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="ma-0 pa-0">
              <v-row class="text-center">
                <v-col>
                  <v-btn
                    :disabled="(sortiepwd == '' || sortiepwd == undefined) || (enteredPwd =='' || enteredPwd == undefined)"
                    class="mr-2 blue darken-4 white--text"
                    @click.native ="validatePassword"
                  >
                    Validate
                  </v-btn>
                  <v-btn
                    class="mr-2 blue darken-4 white--text"
                    @click.native="closePwdDialog"
                  >
                    Close
                  </v-btn>
                </v-col>
              </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </div>      
</template>

<script>
export default {
  name: 'PositionReport',
  components: {
  },
  data() {
    return {
      mission:'',
      enteredPwd:'',
      passwordError: false,
      sortie:'',
      sortiepwd:'',
      httpresponse:'',
      missions:[],
      sorties:[],
      showPasswordVerification:false,
      passwordValidated: false,
      sentObject:'',
      submitted: false,
      location:null,
      gettingLocation: false,
      errorStr:null,
      lat: null,
      lon: null
    }
  },
  created() {

  },
  mounted() {
    this.setBackButtonVisibility(true);
    this.setHomeButtonVisibility(true);
    this.getCellTrackingMissions();
  },
  methods: {
    getLocalTime(epoch) {
      const localTime = this.$moment.unix(epoch/1000).format("YYYY-MM-DD hh:mm")
      return localTime
    },
    validatePassword()
    {

      if(this.sortiepwd.toLowerCase() == this.enteredPwd.toLowerCase())
      {
        this.enteredPwd = "";
        this.sendPositionUpdate()
        this.showPasswordVerification = false
      }
      else
      {
        this.enteredPwd = ""
        this.passwordError = true;
      }

    },
    getCellTrackingMissions()
    {
      // eslint-disable-next-line no-console
      this.$https.get(this.$vars.BaseUrl + this.$vars.GetCellTrackingMissions, this.$vars.config)
        .then(response => {
          //console.log(response);
          this.httpResponse = response;
          this.missions = response.data
        })
        .catch(e => {
          var error = e;
          // eslint-disable-next-line no-console
          console.log(error);
        });
    },
    updateSortiesForMission(mission)
    {
      this.getCellTrackingSorties(mission)
    },
    getCellTrackingSorties(tmission)
    {
      this.$https.get(this.$vars.BaseUrl + this.$vars.GetCellTrackingSorties, this.$vars.config)
        .then(response => {
         // console.log(response);
          this.httpResponse = response;
          this.sorties = response.data.filter(item => item.mission == tmission)
        })
        .catch(e => {
          var error = e;
          // eslint-disable-next-line no-console
          console.log(error);
        });
    },
    getPwdForSortie(sortie)
    {
      var record = this.sorties.filter(item => item.sortie == sortie)
      this.sortiepwd = record[0].sortiepwd
    },
    closePwdDialog()
    {
      this.enteredPwd = ""
      this.passwordError = false;
      this.showPasswordVerification = false
    },
    sendPositionUpdate()
    {

      var error = "";
      var lat = null;
      var lon = null;
      var time = null;

      var obj = {
        capid: null,
        lat: null,
        lon: null,
        time: null,
        mission: null,
        sortie: null
      }

      this.$getLocation({
        enableHighAccuracy: true, //defaults to false
        timeout: 10000, //defaults to Infinity
        maximumAge: 0 //defaults to 0
      })
      .then(pos => {
        console.log(pos);
        this.location = pos;

        obj.capid = this.usercapid
        obj.lat = pos.lat
        obj.lon = pos.lng
        obj.time = Date.now()
        obj.mission = this.mission,
        obj.sortie = this.sortie

        this.sentObject = obj;

        this.$https.post(this.$vars.BaseUrl + this.$vars.UpsertCellTrackingEvent, obj ,this.$vars.config)
        .then(response => {
          // eslint-disable-next-line no-console
          console.log(response);
          this.httpResponse = response;
          this.submitted = true
        })
        .catch(e => {
          var error = e;
          // eslint-disable-next-line no-console
          console.log(error);
        });
      });
    }
  }
}

</script>

<style scoped>
.centerImage {
  margin: auto;
}
</style>
